// @flow
import React from 'react';
import { Modal, Button } from 'antd';
import { SpText } from '../../../widgetDesign';

type Props = {
    visible: Boolean,
    submit: Function,
}

const PolicyConfirmationModal = (props: Props) => {
  const {
    visible, submit,
  } = props;

  const policyItems = [
    'An internet gambling business',
    'Dealing with Controlled Substances (e.g., THC or other Schedule I drugs)',
    'Involved in the sale, distribution, or manufacturing of firearms or ammunition',
    'A government organization',
    'Part of a tax anticipation program',
    'An adult entertainment business',
  ];

  return (
    <Modal
      centered
      closable={false}
      visible={visible}
      footer={[
        <Button onClick={(e) => submit(e, 'NOT_PROCEED')}>
          Yes
        </Button>,
        <Button onClick={(e) => submit(e, 'PROCEED')} type="primary">
          None of the above
        </Button>,
      ]}
      title="Does your company belong to any of the categories listed below?"
    >
      <div className="p-4">
        {policyItems.map((item, index) => (
          <div
            key={index}
            style={{
              display: 'flex',
              alignItems: 'flex-start',
              marginBottom: '16px',
              padding: '12px 0',
            }}
          >
            <div style={{
              width: '6px',
              height: '6px',
              borderRadius: '50%',
              backgroundColor: '#1890ff',
              marginTop: '8px',
              marginRight: '16px',
              flexShrink: 0,
            }}
            />
            <SpText
              fontSize="14px"
              color="#595959"
              style={{
                lineHeight: '1.5',
                flex: 1,
              }}
            >
              {item}
            </SpText>
          </div>
        ))}
      </div>
    </Modal>
  );
};

export default PolicyConfirmationModal;
